import { render, staticRenderFns } from "./WikiIconAndHeaderImage.vue?vue&type=template&id=7d5c0380"
import script from "./WikiIconAndHeaderImage.vue?vue&type=script&lang=ts"
export * from "./WikiIconAndHeaderImage.vue?vue&type=script&lang=ts"
import style0 from "./WikiIconAndHeaderImage.vue?vue&type=style&index=0&id=7d5c0380&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports